import axios from '@/axios/api.request'

export const save = (from) => axios.request({
    url: '/policy/info/save',
    data: from,
    method: 'post'
  })
  export const policys = (from) => axios.request({
    url: '/policy/info/policys',
    data: from,
    method: 'post'
  })